import axios from 'axios'

class StorageFacilityService {
  index () {
    return axios.get('/api/client-account/storage-facilities')
  }
}

export default new StorageFacilityService()
